import { render, staticRenderFns } from "./AutoTaskRuleList.vue?vue&type=template&id=4da74a3c&scoped=true"
import script from "./AutoTaskRuleList.vue?vue&type=script&lang=js"
export * from "./AutoTaskRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da74a3c",
  null
  
)

export default component.exports